import { useMutation } from 'react-query';

import { login } from '../../lib/api';

export type User = {
  result: string;
  userid: string;
};

export type UserInput = {
  username: string;
  password: string;
  noVerify?: boolean;
};

export type APIError = {
  result: 'error';
  message: string;
};
export function useMutateLogin() {
  return useMutation(login);
}
